export default "__VITE_ASSET__B8QQkv4e__"